import {
  label_default
} from "./chunk-X6MMFO33.js";

// src/blocks/label/index.ts
var label_default2 = label_default;

export {
  label_default2 as label_default
};
